import { render, staticRenderFns } from "./EditTaxCode.vue?vue&type=template&id=5408069b&scoped=true&"
import script from "./EditTaxCode.vue?vue&type=script&lang=js&"
export * from "./EditTaxCode.vue?vue&type=script&lang=js&"
import style0 from "./EditTaxCode.vue?vue&type=style&index=0&id=5408069b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408069b",
  null
  
)

export default component.exports